import { ProjectTypeScreenBehaviorBase } from './base/project-type-screen-behavior-base';

export class ProjectTypeScreenBehavior extends ProjectTypeScreenBehaviorBase { }